
//基于设计稿宽度动态计算（假设设计稿宽度为1920px）
function setRootFontSize() {
  // 获取当前窗口宽度
  const windowWidth = document.documentElement.clientWidth;

  // 假设设计稿宽度为1920px，此时1rem = 100px
  const baseSize = 100; // 1rem 对应的像素值
  const designWidth = 1920; // 设计稿宽度

  // 计算当前应该设置的根字体大小
  const fontSize = (windowWidth / designWidth) * baseSize;

  // 设置根元素字体大小
  document.documentElement.style.fontSize = fontSize + 'px';
}

// 监听窗口大小变化
window.addEventListener('resize', setRootFontSize);

// 初始化执行
setRootFontSize();